import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div style={{ padding: '20px' }}>
            <p>
                <strong>주식회사 퓨렘</strong>(이하 ‘회사’라 한다)은 개인정보 보호법 제30조에 따라 정보 주체의 개인정보를 보호하고 
                이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립, 
                공개합니다.
            </p>
            
            <strong style={{ display: 'block', marginTop: '20px' }}>제1조 (개인정보의 처리목적)</strong>
            <p>
                회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 
                이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 
                조치를 이행할 예정입니다.
            </p>
            
            <p>1. 서비스 회원 가입 및 관리</p>
            <p>
                회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별․인증(소셜 로그인, 문자 인증 포함), 회원자격 유지․관리, 서비스 부정 이용 방지, 만 14세 미만 아동의 개인정보처리 시 법정대리인의 동의 여부 확인, 각종 고지․통지, 고충 처리 등을 목적으로 개인정보를 처리합니다.
            </p>
            
            <p>2. 고충 처리</p>
            <p>
                민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락․통지, 처리 결과 통보 등의 목적으로 개인정보를 
                처리합니다.
            </p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제2조 (개인정보의 처리 및 보유기간)</strong>
            <p>① 회사는 법령에 따른 개인정보 보유, 이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유, 이용 기간 내에서 개인정보를 처리, 보유합니다.</p>
            <p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
            <p>1. 앱 회원 가입 및 관리 : 앱 탈퇴 시까지<br />
            다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지</p>
            <p>1) 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료 시까지</p>
            <p>2) 앱 이용에 따른 채권 및 채무관계 잔존 시에는 해당 채권, 채무 관계 정산 시까지</p>

            <p>2. 「통신비밀보호법」 제41조에 따른 통신사실확인자료 보관</p>
            <p>- 가입자 전기통신일시, 개시․종료 시간, 상대방 가입자 번호, 사용도수, 발신기지국 위치추적자료 : 1년</p>
            <p>- 컴퓨터 통신, 인터넷 로그 기록자료, 접속지 추적자료 : 3개월</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제3조 (개인정보의 제3자 제공)</strong>
            <p>① 회사는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.</p>
            <p>② 회사는 원활한 서비스 제공을 위해 다음의 경우 개인정보보호법 제17조 제1항 제1호에 따라 정보주체의 동의를 얻어 필요 최소한의 범위로만 개인정보를 제3자에게 제공할 수 있습니다.</p>
            <p>- 개인정보를 제공받는 자 : &lt;예) (주) OOO 카드&gt;</p>
            <p>- 제공받는 자의 개인정보 이용목적 : &lt;예) 이벤트 공동개최 등 업무제휴 및 제휴 신용카드 발급&gt;</p>
            <p>- 제공하는 개인정보 항목 : &lt;예) 성명, 주소, 전화번호, 이메일주소, 카드결제계좌정보&gt;</p>
            <p>- 제공받는 자의 보유, 이용기간 : &lt;예) 신용카드 발급계약에 따른 거래기간동안&gt;</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제4조(정보주체 및 법정대리인의 권리와 그 행사 방법)</strong>
            <p>① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
            <p>1. 개인정보 열람 요구</p>
            <p>2. 오류 등이 있을 경우 정정 요구</p>
            <p>3. 삭제 요구</p>
            <p>4. 처리 정지 요구</p>
            <p>② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
            <p>③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
            <p>④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
            <p>⑤ 정보주체는 개인정보 보호법 등 관계 법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제5 조(처리하는 개인정보 항목)</strong>
            <p>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>
            <p>1. 앱 회원 가입 및 서비스 이용 시</p>
            <p>필수항목 : 전화번호(문자 인증), 소셜 로그인(구글, 카카오) 시 고유 식별값, 아이디, 비밀번호, 이름</p>
            <p>2. BLE 통신 서비스 이용 시</p>
            <p>필수항목 : 위치 정보(BLE 통신 연결을 위한 스캔), BLE 기기 정보</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제7조(개인정보의 파기)</strong>
            <p>① 회사는 개인정보 보유 기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
            <p>② 정보주체로부터 동의받은 개인정보 보유 기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>
            <p>③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
            <p>1. 파기 절차<br />
            회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</p>
            <p>2. 파기 방법<br />
            회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제8조(개인정보의 안전성 확보조치)</strong>
            <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 하고 있습니다.</p>
            <p>1. 관리적 조치 : 내부관리계획 수립 및 시행, 정기적 직원 교육 등</p>
            <p>2. 기술적 조치 : 개인정보처리시스템 등의 접근 권한 관리, 접근통제시스템 설치, 고유 식별정보 등의 암호화, 보안프로그램 설치</p>
            <p>3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제9조(개인정보 자동 수집 및 거부)</strong>
            <p>① 회사는 앱 서비스 이용 과정에서 이용자의 편의를 도모하고, 서비스 품질을 향상시키기 위해 다음과 같은 정보를 자동으로 수집 및 이용할 수 있습니다.</p>
            <p>- 기기 정보: 단말기 모델명, OS 버전, 기기 식별번호, 언어 및 국가 설정 등</p>
            <p>- 이용 기록: 앱 사용 기록(접속 빈도, 이용 시간), 오류 발생 정보 등</p>
            <p>- BLE 통신 정보: BLE 기기와의 연결을 위한 주변 BLE 기기 정보, 위치 정보(BLE 통신 연결을 위한 스캔 목적) 등</p>
            <p>② 회사는 BLE 통신을 이용한 서비스 제공을 위해 사용자의 위치 정보에 접근합니다. 이는 BLE 기기와의 안정적인 연결 및 서비스 제공에 필수적인 권한입니다. 사용자는 모바일 기기 설정에서 위치 정보 접근 권한을 거부할 수 있으나, 이 경우 BLE 통신을 활용한 서비스 이용이 제한될 수 있습니다.</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제10조(개인정보 보호책임자)</strong>
            <p>① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
            <p>▶ 개인정보 보호책임자<br />
            성명 : 이정숙<br />
            직책 : 대표<br />
            연락처 : 010-7661-0016, 이메일 : joeunfiltech@joeunfiltech.co.kr<br />
            ※ 개인정보 보호 담당부서로 연결됩니다.</p>
            <p>▶ 개인정보 보호 담당부서<br />
            부서명 : 기획/경영/개발 팀<br />
            연락처 : 010-3024-3007, 이메일 : joeunfiltech@joeunfiltech.co.kr</p>
            <p>② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제11조(개인정보 열람청구)</strong>
            <p>정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람 청구가 신속하게 처리되도록 노력하겠습니다.</p>
            <p>▶ 개인정보 열람청구 접수․처리 부서<br />
            부서명 : 기획/경영/개발 팀<br />
            연락처 : 010-3024-3007, 이메일 : joeunfiltech@joeunfiltech.co.kr</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제12조(권익침해 구제 방법)</strong>
            <p>정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.</p>
            <p>1. 개인정보 분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)<br />
            2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)<br />
            3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr)<br />
            4. 경찰청 : (국번없이) 182 (ecrm.police.go.kr/minwon/main)</p>
            <strong style={{ display: 'block', marginTop: '20px' }}>제13조(개인정보 처리방침 시행 및 변경)</strong>
            <p>이 개인정보 처리방침은 2025. 08. 19. 부터 적용됩니다.</p>
        </div>
    );
};

export default PrivacyPolicy;